import { Component, OnInit, Input, ViewChild, TemplateRef, Output, EventEmitter, OnDestroy } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { BsModalService, BsModalRef } from 'ngx-bootstrap';
import { Observable } from 'rxjs/Observable';
import { Store } from '@ngrx/store';
import { ToasterService } from 'angular2-toaster';
import swal from 'sweetalert2';
import * as _ from 'lodash';


import { AddCashOutComponent } from './addCashOut.component';

import { CashOutService, SubscribeService } from '../../../services/index';
import * as moment from 'moment';

//import { AddEditSkuComponent } from './addEditSku.component';
//import { NgxPageSize } from '../../shared/index';

//import { SkuService } from '../../services/index';
import { CashOutModal } from '../../../model/index';

// import * as fromSkuStore from '../../store';
// import * as skuActions from '../../store/actions/sku.actions';
// import * as fromRootStore from '../../reducers';
//import { AppMenu } from '../../../app.component.menu';
//import { AppMenuService } from '../../../app.component.service';
//import { TabsComponent} from '../../../tabs.component';

@Component({
    selector: 'cash-out-list',
    templateUrl: './cashOut.component.html'
})
export class CashOutComponent implements OnInit {
    // @Input('tabTitle') title: string;
    // @Input() active = false;
    // @Input() isCloseable = false;
    // @Input() dataContext;
    //
    isLoadMask: Promise<any>;
    cashOutListData: CashOutModal[];
    //
    loadingIndicator: boolean = true;
    public mode: string;
    // reorderable: boolean = true;
    //
    page = {
        limit: 25,
        count: 0,
        offset: 0,
        // orderBy: 'company_name',
        // orderDir: 'asc'
    };
    //
    @ViewChild('snoTemplate') snoTemplate: TemplateRef<any>;
    @ViewChild('editDeleteTemplate') editDeleteTemplate: TemplateRef<any>;
    @ViewChild('filterPanel') filterPanel;
    //
    columns = [];
    toggleCol = [];
    // filterExpand = false;
    filterData = {
        "from_date": new Date(),
        "to_date": new Date(),
        "search_data": ""
        
    };
    scrollTimeout: any;
    suppressPaging: boolean = false;
    constructor(public toasterService: ToasterService, private cashOutService: CashOutService, public subscribeService: SubscribeService) {
        //console.log(this.gs.rootObj);
    }

    ngOnInit(): void {
        let that = this;
        this.columns = [
            { name: 'SNo', prop: 'sno', width: 70, minWidth: 70, maxWidth: 70, sortable: false, cellTemplate: this.snoTemplate, toggle: true },
            { name: 'Cash Out No', prop: 'cash_out_no', width: 150, minWidth: 150, maxWidth: 150, toggle: true },
            { name: 'Cash Out Date', prop: 'cashout_date', width: 150, minWidth: 150, maxWidth: 150, toggle: true },
            { name: 'Cash To ', prop: 'out_type', width: 150, minWidth: 150, maxWidth: 150 },
            { name: 'To Branch', prop: 'branch_name', width: 150, minWidth: 150, maxWidth: 150 },
            { name: 'HV Team', prop: 'hv_username', width: 150, minWidth: 150, maxWidth: 150 },
            { name: 'Account User', prop: 'acc_user', width: 150, minWidth: 150, maxWidth: 150 },
            { name: 'Amount', prop: 'amount', sortable: false, width: 150, minWidth: 150, maxWidth: 150, cellClass: 'cell-right' },
            { name: 'Action', prop: 'action', width: 180, minWidth: 180, maxWidth: 180, sortable: false, cellClass: 'cell-left', cellTemplate: this.editDeleteTemplate }
        ];
        this.toggleCol = Object.assign({}, this.columns);
        this.pageCallback({ offset: 0 });

        // this.subscribeService.subscribe(($e) => {
        //     this.pageCallback({ offset: 0 });
        // });
        this.subscribeService.publishReloadCashOutGrid().subscribe(($e) => {
            that.pageCallback({ offset: 0 });
        });
    }
    ngOnDestroy() {
        // prevent memory leak when component destroyed
        //this.subscribeService.publishReloadClientWalkInGrid().unsubscribe();
    }
    onOpenedFilter(): void {
        setTimeout(function() {
            $('#filterTextBox').focus();
        }, 100);
    }

    onChangePageSize(limit) {
        this.page.limit = limit;
        this.getCashOutDateList();
    }

    onColumnToggle(colToShow) {
        this.columns = colToShow;
    }

    /**
    * Called whenever the user changes page
    */
    pageCallback(pageInfo: { count?: number, pageSize?: number, limit?: number, offset?: number }) {
        if (!this.suppressPaging) {
            this.page.offset = pageInfo.offset;
            this.getCashOutDateList();
        }
    }
    onScroll() {
        this.suppressPaging = true;
        if (this.scrollTimeout) {
            //celarTimeout(this.scrollTimeout);
        }
        this.scrollTimeout = setTimeout(() => {
            this.suppressPaging = false;
        }, 100)
    }
    clearFilter(): void {
        this.filterData = {
            "from_date": new Date(),
            "to_date": new Date(),
            "search_data": ""
        };
        this.applyFilter();
    }
    applyFilter(): void {
        //this.filterExpand = false;
        this.filterPanel.close();
        this.getCashOutDateList();
    }
    getCashOutDateList(): void {
        let filterData = {
            ...this.filterData,
            from_date:moment(this.filterData['from_date']).format('YYYY-MM-DD'),
            to_date:moment(this.filterData['to_date']).format('YYYY-MM-DD')
        };
        let params = {
            start: `${this.page.offset}`,
            limit: `${this.page.limit}`,
            // orderColumn: `${this.page.orderBy}`,
            // orderDir: `${this.page.orderDir}`,
            filter: JSON.stringify(filterData)
        };
        let that = this;
        //this.store.dispatch(new commonActions.LoadAllSku(params));
        this.isLoadMask = this.cashOutService
            .getCashOutList(params)
            .then(function(res: any) {
                that.loadingIndicator = false;
                that.page.count = res.totCnt;
                that.cashOutListData = res.data;
            });
    }
    addEditCashOut(mode: string, row: any): void {
        let that = this;
        setTimeout(function() {
            that.filterPanel.close();
        }, 10);

        if (mode == "Add") {
            row = {
                'cash_out_id': '',
                mode: mode,
                btnTxt: 'Save'
            };
        } else if (mode == "Edit") {
            row['mode'] = mode;
            row['btnTxt'] = 'Update';
        } else if (mode == "View") {
            row['mode'] = mode;
        }
        that.subscribeService.subScribeTabID('Transaction', 'AddCashOutComponent', Object.assign({}, row), this['params']['tabParams']);

    }

    deleteCashOut(row: any): void {
        let that = this,
            data = {
                cash_out_id: row.cash_out_id
            };
        swal({
            title: 'Are you sure to Delete?',
            text: 'You will not be able to Recover this Details',
            showCancelButton: true,
            confirmButtonText: 'Yes, Delete!',
            cancelButtonText: 'No, Keep it'
        }).then(function() {
            that.isLoadMask = that.cashOutService
                .deleteCashOut(data)
                .then(function(res: any) {
                    that.loadingIndicator = false;
                    if (res.success) {
                        that.getCashOutDateList();
                        swal(
                            'Deleted',
                            res.message,
                            'success'
                        );
                    } else {
                        swal(
                            'ERROR',
                            res.message,
                            'error'
                        );
                    }
                });

        }, function(dismiss) {

        })
    }
    
}



// WEBPACK FOOTER //
// /Applications/MAMP/htdocs/crm-soundsgood/src/app/components/transaction/cashOut/cashOut.component.ts